import styled from "styled-components";

export const TabbedButtonLayout = styled.div`
    margin: 1em auto;
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5em;
`;
